// src/api/auth.js
import axios from 'axios';
import API_PATHS from './ApiPath';
import { getToken } from '../screens/Common/helper';
import { useNavigation } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const getHeaders = async () => {
  try {
    const token = await AsyncStorage.getItem('token');
    const clientToken = await AsyncStorage.getItem('clientToken');
    const authToken = clientToken || token;
    return {
      'Content-Type': 'application/json',
      // Don't send `Bearer null` when the user isn't logged in yet.
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    };
  } catch (error) {
    console.error('Error retrieving token:', error);
    return {
      'Content-Type': 'application/json',
    };
  }
};

// API function to authenticate user
// change this
export const authenticateUser = async (emailOrUserId, password, loginType) => {

  console.log("this is the login type", loginType);

  const body = {
    emailOrUserId: emailOrUserId,
    password: password,
    loginType,
  }

  console.log("this is the body", body);

  try {
    console.log("api path,", `${API_PATHS.BASE_URL}${API_PATHS.LOGIN_API}`);
    const response = await axios.post(
      `${API_PATHS.BASE_URL}${API_PATHS.LOGIN_API}`,
      body,
    );

    console.log("Login response:", response.data);

    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred during login',
    );
  }
};

// API function to get alllocations
export const getAllLocation = async () => {
  const headers = await getHeaders();
  try {
    const response = await axios.get(
      `${API_PATHS.BASE_URL}${API_PATHS.GET_ALL_LOCATIONS_API}`,
      { headers: headers },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};
// /location/event-services — returns the list of bookable event packages
export const getEventServicesApi = async () => {
  const headers = await getHeaders();
  try {
    const response = await axios.get(
      `${API_PATHS.BASE_URL}${API_PATHS.EVENT_SERVICES}`,
      { headers: headers },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};
// /parent/get-All-Kids
export const getAllKidsApi = async () => {
  const headers = await getHeaders();
  try {
    const response = await axios.get(
      `${API_PATHS.BASE_URL}${API_PATHS.GET_ALL_KIDS_API}`,
      {
        headers: headers,
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};


export const getAllPlansApi = async () => {
  const headers = await getHeaders();
  try {
    const response = await axios.get(
      `${API_PATHS.BASE_URL}${API_PATHS.GET_ALL_PLANS}`,
      { headers: headers },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};
export const createKidAi = async (obj) => {
  const headers = await getHeaders();
  try {
    const response = await axios.post(
      `${API_PATHS.BASE_URL}${API_PATHS.CREATE_KIDS}`,
      obj,
      { headers: headers, }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};

export const getAllAddressApi = async (obj) => {
  const headers = await getHeaders();
  try {
    const response = await axios.get(
      `${API_PATHS.BASE_URL}${API_PATHS.GET_ALL_ADDRESS}`, { headers: headers }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};

export const saveRecurringPlanApi = async (obj) => {
  const headers = await getHeaders();
  try {
    const response = await axios.post(
      `${API_PATHS.BASE_URL}${API_PATHS.SAVE_RECURRING}`, { headers: headers, }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || 'An error occurred while fetching data',
    );
  }
};

export const getParentsListApi = async () => {
  const headers = await getHeaders();
  try {
    const response = await axios.post(
      `${API_PATHS.BASE_URL}${API_PATHS.GET_PARENTS}`,
      {
        page: 1,
        limit: 1000,
        sortBy: "PARENT_NAME",
        sortOrder: "ASC"
      },
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'An error occurred while fetching parents',
    );
  }
};

export const generateParentTokenApi = async (obj) => {
  const headers = await getHeaders();
  try {
    const response = await axios.post(
      `${API_PATHS.BASE_URL}${API_PATHS.GENERATE_PARENT_TOKEN}`,
      obj,
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'An error occurred while generating parent token',
    );
  }
};

export const updateFamilyApi = async (token) => {
  const headers = await getHeaders();
  try {
    const response = await axios.post(
      `${API_PATHS.BASE_URL}${API_PATHS.UPDATE_FAMILY}`,
      { token },
      { headers: headers }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'An error occurred while updating family',
    );
  }
};
